
<template>
    <q-page class="row q-pa-lg">
          <!-- for normal/tablet web view -->
         <div class="col gt-xs">
        <q-stepper ref="stepper" v-model="step"  color="primary" animated alternative-labels contractable class="no-shadow">
            <q-step icon="settings"  class="QStepHead" :done="step > 1" :header-nav="step > 1" name="1" :title='$t("stepper.title4")'>
                <q-form class="q-pa-sm">
                    <TransactionBuy></TransactionBuy>
                </q-form>
            </q-step>
            <q-step icon="message" class="QStepHead" :done="step > 2" :header-nav="step > 2" name="2" :title='$t("stepper.title5")'>
                <q-form class="q-pa-sm">
                    <TAC></TAC>
                </q-form>
            </q-step>
            <q-step icon="assignment_turned_in" class="QStepHead" :done="step > 3" :header-nav="step >3" name="3" :title='$t("stepper.title11")'>
                <q-form class="q-pa-sm">
                    <ACK/>
                </q-form>
            </q-step>
        </q-stepper>
        </div>
        <!-- for normal/tablet web view -->

            <!-- for phone web view -->
         <div class="col lt-sm q-mb-lg" style="padding-bottom: 50px;">
        <q-stepper vertical ref="stepper" v-model="step"  color="primary" animated alternative-labels contractable class="no-shadow">
            <q-step icon="settings"  class="QStepHead" :done="step > 1" :header-nav="step > 1" name="1" :title='$t("stepper.title4")'>
                <q-form class="q-pa-sm">
                    <TransactionBuy></TransactionBuy>
                </q-form>
            </q-step>
            <q-step icon="message" class="QStepHead" :done="step > 2" :header-nav="step > 2" name="2" :title='$t("stepper.title5")'>
                <q-form class="q-pa-sm">
                    <TAC></TAC>
                </q-form>
            </q-step>
            <q-step icon="assignment_turned_in" class="QStepHead" :done="step > 3" :header-nav="step >3" name="3" :title='$t("stepper.title11")'>
                <q-form class="q-pa-sm">
                    <ACK/>
                </q-form>
            </q-step>
        </q-stepper>
        </div>
            <!-- for phone web view -->
    </q-page>
</template>
<style lang="stylus">
.QStepHead{
    cursor: default;
}
</style>
<script>
import { mapActions } from 'vuex';
import ACK from '@/components/Acknowledgement.vue'
import TAC from '@/components/TAC.vue'
import Declaration from '@/components/Declaration.vue'
import Navigation from '@/components/NavigationButtons'
import AC from '@/components/ApplicantCredentials.vue'
import AD from '@/components/ApplicantDetails.vue'
import FATCA from '@/components/FATCA.vue'
import ED from "@/components/EmploymentDetails.vue";
import Summary from "@/views/SummaryAccountOpening.vue"
import TransactionBuy from '@/views/TransactionsConfirmation.vue'
import store from '../store';
import {
  Notify
  
} from 'quasar'
export default {
    name: 'LandingPage',
    components:{
        Navigation,    
        Declaration,
        AC,
        AD,
        ED,
        FATCA,
        TAC,
        ACK,
        Summary,
        TransactionBuy
    },
    data(){
    return{
        //fatca
       
        StoreStateLookup : store.state.Lookup,
        StoreStateAD : store.state.AD,
        StoreStateFATCA : store.state.FATCA,
        StoreStateED : store.state.ED,
        StoreStateAO : store.state.AOD,
        StoreStateLogin: store.state.Login,
        StoreStateCD: store.state.CD,
        step:'3',
        apiCall : true,
        counter:1
    }
  },  
 async mounted(){
   store.commit('ResetToken')
    
    store.dispatch("ClearClientDetails")
    store.commit("ResetAODetails");
    store.commit("ResetState_ClientDetails");
    store.commit("ResetTransactionDetails");
    store.commit("ResetState_AD");
    
    var url = new URL(window.location.href);
    var url_string = url.search;
    var TRXNCODE = url.searchParams.get('TRXNCODE');
    var appID = url.searchParams.get('appId');
    var LangToLoad = url.searchParams.get('language');

    if((TRXNCODE != undefined) && (appID != undefined)){
        //move the whole function into this
    this.StoreStateAD.TC_TransactionStatus = TRXNCODE
    if(LangToLoad != undefined){
        
        this.StoreStateLogin.incomingAppID = appID
        if(LangToLoad=='MS'){
            LangToLoad = 'bm'
        }
        this.StoreStateLogin.LanguageToLoad = LangToLoad.toLowerCase();
    }

    //alert(this.StoreStateAD.TC_TransactionStatus)
        // this.$store.dispatch('Logging',{
        //   appid : '2',
        //   typeid :'4', 
        //   str : 'Application ID --> ' + this.StoreStateLogin.incomingAppID + ' Incoming TRX from EPF TAC (buy),  url - > '+  url
        // });
        this.$q.loading.show({
            spinnerSize : 50
        })

         while(this.counter<5){
              await this.EmisApp()
                .then(res=>{
                    if((this.counter===4)&&(this.apiCall===false)){
                        this.$store.dispatch('Logging',{
                            appid : '2',
                            typeid :'4', 
                            str : 'Application ID --> ' + this.StoreStateLogin.incomingAppID + '-> Unable to retrieve API TOKEN' 
                        });
                        this.$router.push({ name: 'Maintenance'});

                        this.$store.dispatch('Logging',{
                          appid : '2',
                          typeid :'4', 
                          str : 'Application ID --> ' + this.StoreStateLogin.incomingAppID + ' Incoming TRX from EPF TAC (buy),  url - > '+  url
                        });
                    }
                })
                this.counter++  
            }      
    }
    else{
        this.StoreStateAD.TC_TransactionStatus = '000'
    }  
      
    //this.$store.dispatch('GetLookup');
  },
  methods:{
       ...mapActions([
           "GETEmisToken",
            "GeteMisStatusCode",
            "GetEmisTransApp",
           "PostTransaction_Submit",
           "PostTransaction_Delete",
           "triggerLogout",
        ]),  

        EmisApp(){
            return new Promise((resolve, reject) => {
                try{
                    this.GETEmisToken({
                        ApplicationId:this.StoreStateLogin.incomingAppID
                    })
                    .then(res=>{

                      this.$httpClient.defaults.headers['Authorization'] = "Bearer " + this.StoreStateLogin.AkamaiToken

                        if(res === true){
                            this.apiCall = true
                            this.counter = 4
                            this.GeteMisStatusCode()
                                .then(res=>{
                                    if(res==true){
                                        this.GetEmisTransApp({
                                            ApplicationId :this.StoreStateLogin.incomingAppID
                                        })
                                        .then(res=>{
                                            //console.log(res)
                                            resolve(this.apiCall) 
                                            if(res==true){
                                                if( this.StoreStateAD.TC_TransactionStatus==='0000'){

                                                        if(this.StoreStateAD.EpfEmisTrxCode==='0000'){
                                                            if(this.StoreStateCD.FormDetails.ApplicationId !=''){
                                                            this.PostTransaction_Submit().then(res=>{
                                                                  this.$q.loading.hide()
                                                            //   resolve(this.apiCall) 
                                                                this.$store.dispatch('Logging',{
                                                                    appid : '2',
                                                                    typeid :'4', 
                                                                    str : 'Application ID --> ' + this.StoreStateLogin.incomingAppID + ' PostTransaction_Submit (buy),  res - > '+  res
                                                                });
                                                           /*      if(res===true){ 
                                                                    this.$q.loading.hide()
                                                                }else{
                                                                    this.$q.loading.hide()
                                                                    this.$q.dialog({
                                                                        title : 'Message',
                                                                        message : 'Error: ' + res 
                                                                    })
                                                                } */
                                                            })
                                                        }else{
                                                            this.$q.loading.hide()
                                                        }
                                                    }else{
                                                      
                                                      this.StoreStateAD.TC_TransactionStatus = this.StoreStateAD.EpfEmisTrxCode
                                                      this.GeteMisStatusCode().then(res=>{ 
                                                        this.$q.loading.hide()
                                                      })
                                                    }
                                                    
                                                }else{                                                    
                                                   // resolve(this.apiCall) 
                                                   // this.$q.loading.hide()
                                                   
                                                        this.$q.loading.hide()
                                                        /* this.PostTransaction_Delete().then(res=>{
                                                        this.$store.dispatch('Logging',{
                                                            appid : '2',
                                                            typeid :'4', 
                                                            str : 'Application ID --> ' + this.StoreStateLogin.incomingAppID + ' PostTransaction_DELETE (buy),  res - > '+  res
                                                        });
                                                      
                                                    }) 
 */
                                                      /* if(res===true){ 
                                                            this.$q.loading.hide()
                                                        }else{
                                                            this.$q.loading.hide()
                                                            this.$q.dialog({
                                                                title : 'Message',
                                                                message : 'Error: ' + res 
                                                            })
                                                        } */
                                                }

                                            }else{
                                                this.StoreStateAD.TC_TransactionStatus==='000'
                                                this.$store.dispatch('Logging',{
                                                    appid : '2',
                                                    typeid :'4', 
                                                    str : 'Application ID --> ' + this.StoreStateLogin.incomingAppID +'. No incoming data'
                                                });
                                                this.$q.dialog({
                                                    title : 'Message',
                                                    message : res.toString(),
                                                     persistent : true
                                                }).onOk(() => {
                                                // console.log('OK')
                                                this.triggerLogout();
                                            }) 
                                                this.$q.loading.hide()
                                            }
                                        })
                                    } else{
                                        this.$q.dialog({
                                            title : 'Message',
                                            message : res.toString()
                                        })
                                        this.$q.loading.hide()
                                    }
                                })
                        }
                        else{
                            this.apiCall = false
                            resolve(this.apiCall) 
                        }            
                    })
                }catch(err) {
                    this.apiCall = false
                    reject( this.apiCall)
                }
            })

        }
  }
}
</script>